import React from 'react';
import './index.scss';
import {
    DatePicker,
    Radio,
    Input,
    Form,
    Select,
    Modal,
    Button,
    InputNumber,
    message,
    Checkbox,
    Icon
} from 'antd';
import moment from 'moment';
import toast from '@util/toast';
const { RangePicker } = DatePicker;
const { Option } = Select;

export default class VoteDialogAndt extends React.Component<any, any> {
    private voteOptionsItem = [
        {
            content: '',
            optionFile: null
        }
    ];
    constructor(props) {
        super(props);
        this.state = {
            index: -1,
            visibility: false,
            voteType: 'multiple',
            singleFlieList: [],
            date: [],
            title: '',
            // remark: '',
            voteOptions: [
                {
                    content: '',
                    optionFile: null
                }
            ],
            maxChoice: 1,
            isAnonymity: 0,
            isTop: true,
            voteImgList: [],
            actionType: 'add'
        };
    }
    public showModal = (data, actionType, index, validAtMax, validAtMin) => {
        if (data) {
            const {value, isTop,  isAnonymity, voteData, date} = data;
            const {
                type,
                options,
                maxChoice,
                images,
            } = voteData;
            this.setState({
                index,
                date: date || [moment(validAtMin), moment(validAtMax)],
                title: value,
                maxChoice,
                voteType: type,
                voteOptions: options,
                isAnonymity,
                isTop,
                voteImgList: {
                    images
                }
            });
        } else {
            this.clearVoteData();
        }
        this.setState({ visibility: true, actionType });
    };
    public hideModal = () => {
        this.setState({
            visibility: false
        });
        this.clearVoteData();
    };
    public clearVoteData = () => {
        this.setState({
            // date: [],
            title: '',
            // remark: '',
            voteOptions: JSON.parse(JSON.stringify(this.voteOptionsItem)),
            maxChoice: 1,
            voteType: 'multiple',
            isAnonymity: 0,
            isTop: true,
            voteImgList: {}
        });
    };
    public typeChange = val => {
        this.setState({
            voteType: val,
            voteOptions: JSON.parse(JSON.stringify(this.voteOptionsItem)),
            voteImgList: [],
            actionType: 'change'
        });
        this.props.imgInputChange(null, 1, 'change');
    };
    public uploadChnage = (index, files) => {
        this.setState({
            voteOptions: this.state.voteOptions.map((item, inx) => {
                if (index === inx) {
                    item.optionFile = files.file;
                }
                return item;
            })
        });
    };
    public submitVoteData = () => {
        const {
            date,
            title,
            voteType,
            voteOptions,
            maxChoice,
            isAnonymity,
            isTop,
            index,
            actionType
        } = this.state;
        const result = {
            date,
            title,
            // remark,
            type: voteType,
            options: voteType === 'singleText' ? [] : voteOptions,
            maxChoice,
            isAnonymity,
            voteImgList: this.state.voteImgList
        };
        if (title === '') {
            message.error('请填写题目！');
            return false;
        }
        let hsaOptionTitle: boolean;
        voteOptions.forEach(item => {
            if (item.content) {
                hsaOptionTitle = true;
            } else {
                hsaOptionTitle = false;
                return;
            }
        });
        if (!hsaOptionTitle && voteType !== 'singleText') {
            return message.error('请填写选项内容！');
        }
        this.props.addContentVote(result, isTop, index, actionType);
        this.hideModal();
    };
    public dateChange = date => {
        this.setState({ date: date });
    };
    public titleChange = e => {
        this.setState({ title: e.target.value });
    };
    public addVoteOption = (): any => {
        // if (this.state.voteOptions.length >= this.state.maxChoice) {
        //     return false;
        // }
        const voteOptions = [
            ...this.state.voteOptions,
            ...JSON.parse(JSON.stringify(this.voteOptionsItem))
        ];
        this.setState({
            voteOptions
        });
    };
    public maxChoiceChnage = maxChoice => {
        this.setState({ maxChoice: maxChoice || 999 });
    };
    public optionTitleChange = (index, e) => {
        this.setState({
            voteOptions: this.state.voteOptions.map((item, inx) => {
                if (index === inx) {
                    item.content = e.target.value;
                }
                return item;
            })
        });
    };
    public onChangeCheckbox = e => {
        const isAnonymity = e.target.checked ? 1 : 0;
        this.setState({ isAnonymity });
    };
    public onPlaceChange = e => {
        this.setState({ isTop: e.target.value  });
    };
    public imgInputChange = (e, index) => {
        const type = this.state.actionType;
        this.props.imgInputChange(e, index, type, this.props.voteImgList.images || this.state.voteImgList.images);
        // this.setState({ actionType: 'add' });
    };
    public delImg = index => {
        const voteImgList = this.props.voteImgList.images;
        voteImgList.splice(index, 1, '');
        const  voteOptions = this.state.voteOptions.slice()
        voteOptions[index].url='';
        
        this.setState({ voteImgList, voteOptions});
    };
    public delOption = index => {
        const { voteOptions } = this.state;
        const voteImgList = this.props.voteImgList.images;
        voteOptions.splice(index, 1);
        voteImgList && voteImgList.splice(index, 1);
        this.setState({ voteOptions, voteImgList});
    };

    render() {
        const {
            visibility,
            voteType,
            singleFlieList,
            voteOptions,
            date,
            title,
            isTop,
            maxChoice,
            actionType,
            isAnonymity,
        } = this.state;
        const { voteImgList } = this.props;
        let images = [];
        if (voteImgList.images) {
            if (actionType === 'add' || actionType === 'edit') {
                images = voteImgList.images;
            } else if (actionType === 'change') {
                images = this.state.voteImgList || [];
            }
        }
        return (
            <Modal
                title={actionType !== 'edit'?'插入投票':'编辑投票'}
                visible={visibility}
                destroyOnClose={true}
                maskClosable={false}
                onCancel={() => this.hideModal()}
                // onOk={()=>this.submitVoteData()}
                // footer={[
                //     <Button onClick={() => this.hideModal()}>取消</Button>,
                //     <Button onClick={this.submitVoteData}>确认</Button>
                // ]}
                onOk={this.submitVoteData}>
                <Form
                    name="vote"
                    labelCol={{ span: 4 }}
                    wrapperCol={{ span: 18 }}>
                    <Form.Item label="日期">
                        <RangePicker
                            defaultValue={date}
                            onChange={this.dateChange}
                            showTime
                            allowClear
                            placeholder={['投票开始日期', '投票结束日期']}
                            style={{ width: '100%' }}
                        />
                    </Form.Item>
                    <Form.Item label="位置">
                    <Radio.Group onChange={this.onPlaceChange} defaultValue={isTop} disabled={actionType === 'edit'}>
                        <Radio value={true}>顶部</Radio>
                        <Radio value={false}>底部</Radio>
                    </Radio.Group>
                    </Form.Item>
                    <Form.Item label="题目">
                        <Input
                            defaultValue={title}
                            maxLength={50}
                            onChange={this.titleChange}
                            type="text"
                            className="dialog-input"
                            placeholder="投票题目"
                        />
                    </Form.Item>
                    {/* <Form.Item label="备注">
                        <Input
                            defaultValue={remark}
                            maxLength={50}
                            onChange={this.remarkChange}
                            type="text"
                            className="dialog-input"
                            placeholder="投票备注"
                        />
                    </Form.Item> */}
                    <Form.Item label="类型">
                        {/* <Form.Item label="类型" colon={false}> */}
                        <Select
                            defaultValue={voteType}
                            style={{ width: 120 }}
                            disabled={actionType === 'edit'}
                            onChange={this.typeChange}>
                            <Option value="singleText">单行文本题</Option>
                            <Option value="single">单选题</Option>
                            <Option value="multiple">多选题</Option>
                        </Select>
                        {(voteType === 'multiple' || voteType === 'single') && (
                            <Checkbox
                                className="vote-isAnonymity"
                                checked={isAnonymity === 1 ? true : false}
                                onChange={this.onChangeCheckbox}>
                                不记名投票
                            </Checkbox>
                        )}
                    </Form.Item>

                    {voteType === 'single' && (
                        <Form.Item label="选项">
                            {voteOptions.map((item, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <Input
                                            type="text"
                                            onChange={this.optionTitleChange.bind(
                                                this,
                                                index
                                            )}
                                            defaultValue={item.content}
                                            className="dialog-input dialog-input-option"
                                            placeholder="选项"
                                        />
                                        {index > 0 && actionType !== 'edit' && (
                                            <Icon
                                                className="closeOption"
                                                onClick={() =>
                                                    this.delOption(index)
                                                }
                                                type="close"></Icon>
                                        )}
                                        {!(images[index] && images[index].url.length > 0) && (
                                            <div className="add-img">
                                                <input
                                                    type="file"
                                                    onChange={(
                                                        event: React.ChangeEvent<
                                                            HTMLInputElement
                                                        >
                                                    ) => {
                                                        this.imgInputChange(
                                                            event,
                                                            index
                                                        );
                                                    }}
                                                    name="question-img"
                                                    id="question-img"
                                                    value=""
                                                    multiple={false}
                                                    accept="image/jpg,image/jpeg,image/png,image/gif"
                                                />
                                                <span className="iconfont">
                                                    &#xe71d;
                                                </span>
                                            </div>
                                        )}
                                        {images[index] && images[index].url.length > 0 && (
                                            <div className="add-img-show">
                                                <div
                                                    className="imgClose"
                                                    onClick={() =>
                                                        this.delImg(index)
                                                    }></div>
                                                <img
                                                    src={
                                                        images[index].url
                                                    }></img>
                                            </div>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            {actionType !== 'edit' && (
                                <Button
                                    type="dashed"
                                    block
                                    onClick={this.addVoteOption}>
                                    新建选项
                                </Button>
                            )}
                        </Form.Item>
                    )}
                    {voteType === 'multiple' && (
                        <Form.Item label=" " colon={false}>
                            <span>最多可选数量：</span>
                            <InputNumber
                                defaultValue={maxChoice}
                                min={1}
                                onChange={this.maxChoiceChnage}
                            />
                            {voteOptions.map((item, index) => {
                                return (
                                    <React.Fragment key={index}>
                                        <Input
                                            type="text"
                                            onChange={this.optionTitleChange.bind(
                                                this,
                                                index
                                            )}
                                            value={item.content}
                                            className="dialog-input-option"
                                            placeholder="选项"
                                        />
                                        {index > 0 && actionType !== 'edit' && (
                                            <Icon
                                                className="closeOption"
                                                onClick={() =>
                                                    this.delOption(index)
                                                }
                                                type="close"></Icon>
                                        )}

                                        {!(images[index] && images[index].url.length > 0) && (
                                            <div className="add-img">
                                                <input
                                                    type="file"
                                                    onChange={(
                                                        event: React.ChangeEvent<
                                                            HTMLInputElement
                                                        >
                                                    ) => {
                                                        this.imgInputChange(
                                                            event,
                                                            index
                                                        );
                                                    }}
                                                    name="question-img"
                                                    id="question-img"
                                                    value=""
                                                    multiple={false}
                                                    accept="image/jpg,image/jpeg,image/png,image/gif"
                                                />
                                                <span className="iconfont">
                                                    &#xe71d;
                                                </span>
                                            </div>
                                        )}
                                        {images[index] && images[index].url.length > 0 && (
                                            <div className="add-img-show">
                                                <div
                                                    className="imgClose"
                                                    onClick={() =>
                                                        this.delImg(index)
                                                    }></div>
                                                <img
                                                    src={
                                                        images[index].url
                                                    }></img>
                                            </div>
                                        )}
                                    </React.Fragment>
                                );
                            })}
                            <Button
                                type="dashed"
                                block
                                onClick={this.addVoteOption}>
                                新建选项
                            </Button>
                        </Form.Item>
                    )}
                </Form>
            </Modal>
        );
    }
}
